import React, { type MouseEventHandler, type HTMLAttributes } from 'react'
import { useDayPicker } from 'react-day-picker'
import { toDate } from '../toDate'

export const Nav = (
  props: {
    onPreviousClick?: MouseEventHandler<HTMLButtonElement>
    onNextClick?: MouseEventHandler<HTMLButtonElement>
    previousMonth?: Date | undefined
    nextMonth?: Date | undefined
  } & HTMLAttributes<HTMLElement>,
) => {
  const { onPreviousClick: _onPreviousClick, onNextClick: _onNextClick, previousMonth, nextMonth, ...navProps } = props

  const { months, components, labels } = useDayPicker()

  const currentMonthDate = toDate(months[0].date)

  return (
    <nav {...navProps} className="flex items-center justify-center gap-4 mb-4">
      <components.PreviousMonthButton
        type="button"
        tabIndex={previousMonth ? undefined : -1}
        disabled={previousMonth ? undefined : true}
        onClick={props.onPreviousClick}
        className={previousMonth ? '' : 'opacity-50'}
      >
        <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" width="32" height="32" rx="16" fill="#F9FAFB" />
          <path d="M19.675 12.175L18.5 11L13.5 16L18.5 21L19.675 19.825L15.8583 16L19.675 12.175Z" fill="#8B9096" />
        </svg>
      </components.PreviousMonthButton>
      <div className="relative w-fit text-lg text-center whitespace-nowrap font-medium">
        {document.documentElement.lang === 'ja'
          ? `${currentMonthDate.getFullYear()}年${currentMonthDate.getMonth() + 1}月`
          : labels.labelGrid(currentMonthDate)}
      </div>
      <components.NextMonthButton
        type="button"
        tabIndex={nextMonth ? undefined : -1}
        disabled={nextMonth ? undefined : true}
        onClick={props.onNextClick}
        className={nextMonth ? '' : 'opacity-50'}
      >
        <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" width="32" height="32" rx="16" fill="#F9FAFB" />
          <path d="M14.675 11L13.5 12.175L17.3167 16L13.5 19.825L14.675 21L19.675 16L14.675 11Z" fill="#8B9096" />
        </svg>
      </components.NextMonthButton>
    </nav>
  )
}
